// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__landingPage {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  z-index: 0;
  position: relative;
}

.app__landingpage_img {
  max-width: 100%;
  width: 100%;
  min-width: 560px;
  margin: 0 auto;
  z-index: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.app__landingPage_buttons {
  display: flex;
  margin-bottom: 100px;
}
.app__scroll__down__icon {
  cursor: pointer;
  margin-bottom: 100px;
  position: relative;
  opacity: 0.6; /* Reduziere die Sichtbarkeit des Pfeils */
  animation: bounce 2s infinite alternate;
}
.app__scroll__down__icon_startseite {
  cursor: pointer;
  margin-bottom: 20px;
  position: relative;
  opacity: 0.6; /* Reduziere die Sichtbarkeit des Pfeils */
  animation: bounce 2s infinite alternate;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(
      10px
    ); /* Ändere den Wert, um die Höhe des Bounces anzupassen */
  }
}
.app__landingPage_container-icon-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.app__landingPage_button {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  background: linear-gradient(to right, #a07846 0%, #f5dcaf 100%);
  color: var(--color-white);
  font-weight: 700;
  font-family: "SawtonCircular-Bold";
  letter-spacing: 0.04em;
  line-height: 28px;
  font-size: 22px;
  padding: 0.25rem 1.5rem;
  width: 190px;
  gap: 10px;
  margin-bottom: 50px;
  margin: 5px;
  border-radius: 10px;
  border: none;
  outline: none;
  cursor: pointer;
}

.app__landingPage_button::before {
  content: "";

  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shimmer 2s linear infinite alternate;
  transition: background-color 0.4s ease;
  border-radius: 10px; /* Füge die border-radius Eigenschaft hinzu */
}
.app__landingPage_button:hover {
  background-color: rgba(
    165,
    120,
    70,
    0.8
  ); /* Dunklere Farbe im Hover-Zustand */
  box-shadow: 0px 0px 20px 8px rgba(165, 120, 70, 0.8); /* Sanfterer Leuchteffekt */
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@media screen and (max-width: 1200px) {
  .app__landingPage_button {
    font-size: 16px;
    width: 120px;
    padding: 0.25rem 0.75rem;
    background-color: rgba(
      165,
      120,
      70,
      0.8
    ); /* Dunklere Farbe im Hover-Zustand */
    box-shadow: 0px 0px 20px 8px rgba(165, 120, 70, 0.4); /* Sanfterer Leuchteffekt */
  }

  .app__landingPage_button::before {
    content: none; /* Entferne den Pseudo-Element-Inhalt */
  }
}

@media screen and (max-width: 320px) {
  .app__landingpage_img {
    min-width: 470px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/LandingPageHeader/landingPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,YAAY,EAAE,0CAA0C;EACxD,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY,EAAE,0CAA0C;EACxD,uCAAuC;AACzC;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE;;KAEC,EAAE,wDAAwD;EAC7D;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,4DAA4D;EAC5D,+DAA+D;EAC/D,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,+CAA+C;EAC/C,sCAAsC;EACtC,mBAAmB,EAAE,6CAA6C;AACpE;AACA;EACE;;;;;GAKC,EAAE,oCAAoC;EACvC,oDAAoD,EAAE,2BAA2B;AACnF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB;;;;;KAKC,EAAE,oCAAoC;IACvC,oDAAoD,EAAE,2BAA2B;EACnF;;EAEA;IACE,aAAa,EAAE,uCAAuC;EACxD;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".app__landingPage {\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  overflow: hidden;\r\n  z-index: 0;\r\n  position: relative;\r\n}\r\n\r\n.app__landingpage_img {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  min-width: 560px;\r\n  margin: 0 auto;\r\n  z-index: 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 10px;\r\n}\r\n\r\n.app__landingPage_buttons {\r\n  display: flex;\r\n  margin-bottom: 100px;\r\n}\r\n.app__scroll__down__icon {\r\n  cursor: pointer;\r\n  margin-bottom: 100px;\r\n  position: relative;\r\n  opacity: 0.6; /* Reduziere die Sichtbarkeit des Pfeils */\r\n  animation: bounce 2s infinite alternate;\r\n}\r\n.app__scroll__down__icon_startseite {\r\n  cursor: pointer;\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n  opacity: 0.6; /* Reduziere die Sichtbarkeit des Pfeils */\r\n  animation: bounce 2s infinite alternate;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(\r\n      10px\r\n    ); /* Ändere den Wert, um die Höhe des Bounces anzupassen */\r\n  }\r\n}\r\n.app__landingPage_container-icon-btn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.app__landingPage_button {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden;\r\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n  background: linear-gradient(to right, #a07846 0%, #f5dcaf 100%);\r\n  color: var(--color-white);\r\n  font-weight: 700;\r\n  font-family: \"SawtonCircular-Bold\";\r\n  letter-spacing: 0.04em;\r\n  line-height: 28px;\r\n  font-size: 22px;\r\n  padding: 0.25rem 1.5rem;\r\n  width: 190px;\r\n  gap: 10px;\r\n  margin-bottom: 50px;\r\n  margin: 5px;\r\n  border-radius: 10px;\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.app__landingPage_button::before {\r\n  content: \"\";\r\n\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(\r\n    90deg,\r\n    transparent,\r\n    rgba(255, 255, 255, 0.2),\r\n    transparent\r\n  );\r\n  animation: shimmer 2s linear infinite alternate;\r\n  transition: background-color 0.4s ease;\r\n  border-radius: 10px; /* Füge die border-radius Eigenschaft hinzu */\r\n}\r\n.app__landingPage_button:hover {\r\n  background-color: rgba(\r\n    165,\r\n    120,\r\n    70,\r\n    0.8\r\n  ); /* Dunklere Farbe im Hover-Zustand */\r\n  box-shadow: 0px 0px 20px 8px rgba(165, 120, 70, 0.8); /* Sanfterer Leuchteffekt */\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% {\r\n    transform: translateX(-100%);\r\n  }\r\n  100% {\r\n    transform: translateX(100%);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .app__landingPage_button {\r\n    font-size: 16px;\r\n    width: 120px;\r\n    padding: 0.25rem 0.75rem;\r\n    background-color: rgba(\r\n      165,\r\n      120,\r\n      70,\r\n      0.8\r\n    ); /* Dunklere Farbe im Hover-Zustand */\r\n    box-shadow: 0px 0px 20px 8px rgba(165, 120, 70, 0.4); /* Sanfterer Leuchteffekt */\r\n  }\r\n\r\n  .app__landingPage_button::before {\r\n    content: none; /* Entferne den Pseudo-Element-Inhalt */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n  .app__landingpage_img {\r\n    min-width: 470px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
